module.exports = __webpack_public_path__ + "img/tortoise.34c67253.svg";